module.exports = __webpack_public_path__ + "static/media/lucas-8.jpeg";